import { type AppBusySnapshot, snapshot } from "@core-ui/AppBusy";

// Diagnostic snapshot for e2e and manual debugging; product code reads the counter via useBusy.
// Imported for its side effect (ContextProviders), including on platforms that never take a hold.

declare global {
	interface Window {
		appBusy?: () => AppBusySnapshot;
	}
}

// A global of its own rather than window.debug: each app's entry point reassigns that object
// after this module runs, which would silently drop the property.
if (typeof window !== "undefined") window.appBusy = snapshot;
